import type { ReactNode } from 'react';
import { Panel } from './Panel';

/**
 * De zoekrij boven een lijst: één invoerveld, ruimte voor extra filters, en de
 * teller rechts.
 *
 * Er stonden vijf identieke kopieën van dezelfde `searchStyle` in de app, plus een
 * zesde variant op het wagenpark die in een witte kaart zat met twee dropdowns
 * ernaast. Vijf keer hetzelfde object en toch net niet hetzelfde beeld: de één
 * zweefde op de achtergrond, de ander stond in een kaart, en de placeholders
 * zeiden om en om "Zoek op" en "Filter op". Nu is het één component, dus de
 * volgende lijst hoeft niets te kopiëren en kan er ook niet vanaf gaan wijken.
 *
 * De teller blijft van de aanroeper: elke lijst telt iets anders ("12 van 30
 * auto's", "30 passen") en dat is geen kennis van dit component.
 */
export function ZoekBalk({
  waarde,
  onWaarde,
  placeholder,
  ariaLabel,
  aantal,
  children,
}: {
  waarde: string;
  onWaarde: (waarde: string) => void;
  placeholder: string;
  ariaLabel?: string;
  /** Rechts uitgelijnd, bijvoorbeeld "12 van 30 passen". */
  aantal?: string;
  /** Extra filters naast het zoekveld, zoals de dropdowns op het wagenpark. */
  children?: ReactNode;
}) {
  return (
    <Panel
      padding={0}
      style={{
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      <input
        value={waarde}
        onChange={(e) => onWaarde(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        style={{
          flex: '1 1 260px',
          fontFamily: 'inherit',
          fontSize: 14,
          padding: '9px 12px',
          border: '1px solid #C9BCA9',
          borderRadius: 4,
          background: '#FBF5EE',
          color: '#111111',
        }}
      />
      {children}
      {aantal && (
        <span style={{ fontSize: 12, color: '#888888', marginLeft: 'auto' }}>{aantal}</span>
      )}
    </Panel>
  );
}
